import React, { Component } from 'react';
import { user } from '@myplay/all';
import { MonitorsTable } from '..';

import './MainPage.scss';

class MainPage extends Component {
  state = {
    hasAccessToken: false
  };

  async componentDidMount() {
    try {
      const params = new URLSearchParams(window.location.search);
      if(!params.get('accessToken')){
        window.location.href = `${process.env.REACT_APP_MYPLAY_IDENTITY_URI}?redirect=${window.location.origin}`;
        return;
      }
      await user.auth.setAccessToken(params.get('accessToken'));
      await user.auth.setRefreshToken(params.get('refreshToken'));
      this.setState({
        hasAccessToken: true
      });
    } catch (error) {
      console.log(error);
    }
  };


  render() {
    const { hasAccessToken } = this.state;
    return (
      <div className="main-page">
        {hasAccessToken && <MonitorsTable />}
      </div>
    )
  }
};

export default MainPage;